import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import Notifications from "vue-notification";
import mixinsCommon from "./mixins/common";

// Firebase Analytics用のimport

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

//import './registerServiceWorker'
import { unregister } from "register-service-worker";
unregister();

// Firebase設定
const firebaseConfig = {
  apiKey: "AIzaSyDBDXLgPWIo4ogvh8QOXdGUGVwCMVf7q4M",
  authDomain: "shikuchoson-d5290.firebaseapp.com",
  projectId: "shikuchoson-d5290",
  storageBucket: "shikuchoson-d5290.firebasestorage.app",
  messagingSenderId: "835303463004",
  appId: "1:835303463004:web:d74e28daf210ed56edae99",
  measurementId: "G-XS8MQ8GRY8",
};

// Firebase初期化
const app = initializeApp(firebaseConfig);
getAnalytics(app);

Vue.config.productionTip = false;
Vue.use(Notifications);
Vue.mixin(mixinsCommon);

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
